<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title class="pl-0">
          {{ $t("settings_compset_booking_url") }}
        </v-card-title>
        <a-booking-url-field
          v-model="item.settings.me_competitor_booking_url"
          :label="$t('hotel_booking_url')"
          hint="https://www.booking.com/hotel/{iso}/{nombre-hotel}.{iso}.html"
          :clean-https="false"
          class="pr-8"
          outlined
          rounded
          dense
        ></a-booking-url-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-title class="pl-0">
          {{ $t("settings_compset_competitors") }}
        </v-card-title>
        <v-row
          v-for="(url, index) in item.settings.competitors_booking_urls"
          :key="index"
        >
          <v-col cols="6" class="py-0 d-flex align-start">
            <a-booking-url-field
              v-model="item.settings.competitors_booking_urls[index]"
              :label="$t('hotel_booking_url')"
              hint="https://www.booking.com/hotel/{iso}/{nombre-hotel}.{iso}.html"
              :clean-https="false"
              @paste="onPaste"
              outlined
              rounded
              dense
              class="flex-grow-1"
            ></a-booking-url-field>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon class="ml-2" @click="removeUrl(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              {{ $t("delete_url") }}
            </v-tooltip>
          </v-col>
        </v-row>
        <div class="d-flex justify-start mb-4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="addUrl">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            {{ $t("add_url") }}
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import aBookingUrlField from "@/components/aBookingUrlField";

export default {
  name: "a-hotel-compset",
  components: {
    aBookingUrlField
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      },
      required: true
    }
  },
  methods: {
    addUrl() {
      this.item.settings.competitors_booking_urls.push("");
    },
    removeUrl(index) {
      this.item.settings.competitors_booking_urls.splice(index, 1);
    },
    onPaste: function(e) {
      let pastedText = undefined;
      if (window.clipboardData && window.clipboardData.getData) {
        // IE
        pastedText = window.clipboardData.getData("Text");
      } else if (e.clipboardData && e.clipboardData.getData) {
        pastedText = e.clipboardData.getData("text/plain");
      }
      if (pastedText !== undefined) {
        const lines = pastedText.split("\n");
        if (lines.length > 1) {
          e.preventDefault();
          this.item.settings.competitors_booking_urls = [];
          for (let i = 0; i < lines.length; i++) {
            if (lines[i].trim() !== "") {
              this.item.settings.competitors_booking_urls.push(lines[i].trim());
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped></style>
